import styled from 'styled-components';
import { Tooltip } from 'react-leaflet';

export const StyledTooltip = styled(Tooltip)`
  background-color: white;
  font-family: Poppins, sans-serif;
`;
